const makeKnownAdvancements = (initialArray) => {
    const known = {};
    const used = {};
    for (let id of initialArray) {
        known[id] = true;
    }
 
    return {
        learn: advancementId => {
            known[advancementId] = true;
        },

        use: advancementId => {
            used[advancementId] = true;
        },

        isKnown: advancementId => known[advancementId],

        isUsed: advancementId => known[advancementId],

        knownCount: () => Object.keys(known).length,

        usedCount: () => Object.keys(used).length,

        allKnown: () => Object.keys(known)
    }
};

export default makeKnownAdvancements;